export class GameWinPresentationEvents {
	public static readonly AFTER_MULTIPLIER_COUNTING_FINISHED: string = 'GameWinPresentationEvents::AFTER_MULTIPLIER_COUNTING_FINISHED';
	public static readonly PRE_MULTIPLIER_BIG_WIN_FINISHED: string = 'GameWinPresentationEvents::PRE_MULTIPLIER_BIG_WIN_FINISHED';
	public static readonly COUNTING_STARTED: string = 'GameWinPresentationEvents::COUNTING_STARTED';
}



// WEBPACK FOOTER //
// ./src/winpresentation/GameWinPresentationEvents.ts